(function () {
    'use strict';

    angular.module("imApp").factory("furnitureFabricsService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1182,
                    parameters: parms || {}
                });
            },
            listProductChoices: function (parms) {
                return $ihttp.post({
                    method: 1159,
                    parameters: parms || {}
                });
            },
            listFabricGroups: function (parms) {
                return $ihttp.post({
                    method: 1240,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1217,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
